import FormattedMessage from 'I18n/components/FormattedMessage';
import { unreachableFallback } from 'ui-product-approvals-common/utils/unreachableFallback';
import { jsx as _jsx } from "react/jsx-runtime";
export const ApprovalEditPanelTooltipI18n = ({
  approvalType
}) => {
  switch (approvalType) {
    case 'MARKETING_EMAIL':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEditPanel.tooltipReassignApprovers.MARKETING_EMAIL"
        });
      }
    case 'LANDING_PAGE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEditPanel.tooltipReassignApprovers.LANDING_PAGE"
        });
      }
    case 'SITE_PAGE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEditPanel.tooltipReassignApprovers.SITE_PAGE"
        });
      }
    case 'BLOG_POST':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEditPanel.tooltipReassignApprovers.BLOG_POST"
        });
      }
    case 'DEAL':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEditPanel.tooltipReassignApprovers.DEAL"
        });
      }
    case 'KNOWLEDGE_ARTICLE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEditPanel.tooltipReassignApprovers.KNOWLEDGE_ARTICLE"
        });
      }
    case 'QUOTE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEditPanel.tooltipReassignApprovers.QUOTE"
        });
      }
    case 'SOCIAL_BROADCAST':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEditPanel.tooltipReassignApprovers.SOCIAL_BROADCAST"
        });
      }
    case 'CONNECTED_APP':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalEditPanel.tooltipReassignApprovers.CONNECTED_APP"
        });
      }
    default:
      return unreachableFallback(approvalType, /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.unhandled.approvalType"
      }));
  }
};